<template>
    <!-- TODO, remove this, replace with actual filters -->
    <div class="filter1 overflow-auto">
        <div class="m-4 h4 font-weight-bold">
            Filters coming soon
        </div>
        <div class="m-4 h5">
            Filter1
        </div>
        <div class="m-4 h5">
            Filter2
        </div>
        <!-- <div class="cta">
            <b-button 
                variant="primary"
                :pressed=clicked_nearyou_pressed
                @click="clicked_nearyou"
            >
                Near you
            </b-button>
        </div>
        <div class="cta">
            <b-button 
                variant="primary"
                :pressed=clicked_popular_pressed
                @click="clicked_popular"
            >
                Popular
            </b-button>
        </div>
        <div class="cta">
            <b-button 
                variant="primary"
                :pressed=clicked_foryou_pressed
                @click="clicked_foryou"
            >
                Recommended for you
            </b-button>
        </div> -->
    </div>
    
</template>

<style scoped>
.filter1 {
    /* background-color: green; */
    /* height: 85vh; */
    /* z-index: 500; */
    height: 100%;
}


.cta {
    margin: 10px;
}

</style>

<script>
export default {
    data() {
        return {
            clicked_nearyou_pressed: true,
            clicked_popular_pressed: false,
            clicked_foryou_pressed: false
        }
    },
    methods: {
        clicked_nearyou() {
            console.log('nearyou')
            this.clicked_nearyou_pressed = true
            this.clicked_popular_pressed = false
            this.clicked_foryou_pressed = false
            this.$store.dispatch('place_setCurrentPage', 1)
            this.$store.dispatch('retrievePlacesNearYou')
        },
        clicked_popular() {
            console.log('popular')
            this.clicked_nearyou_pressed = false
            this.clicked_popular_pressed = true
            this.clicked_foryou_pressed = false
            this.$store.dispatch('place_setCurrentPage', 1)
            this.$store.dispatch('retrievePlacesPopular')
        },
        clicked_foryou() {
            console.log('foryou')
            this.clicked_nearyou_pressed = false
            this.clicked_popular_pressed = false
            this.clicked_foryou_pressed = true
            this.$store.dispatch('place_setCurrentPage', 1)
            this.$store.dispatch('retrievePlacesForYou')
        }
    },
    computed: {
        
    },
    mounted() {
        console.log('mounted')
    }
}
</script>